import { Alert, AlertTitle, Paper, Typography } from "@mui/material";
import { FC, useMemo, useState } from "react";

import SubscriptionActivitiesList from "web/Layout/SubscriptionActivities";
import __ from "web/Layout/Translations";

import getRequiredActivitiesMUI from "web/utils/page/product/subscription/getRequiredActivitiesMUI";

import { ISubscriptionUserCurrent } from "web/types/Subscription";

interface IRequiredActivitiesProps {
  hasReceiverFormsToFill: boolean;
  hasPdfBarcodes: boolean;
  showOfflineDeclarations: boolean;
  data: ISubscriptionUserCurrent;
}

const setMessageType = (
  hasBenefitsWithReceiverForms: boolean,
  hasBenefitsWithPdfForms: boolean,
  showOfflineDeclarations: boolean
) => {
  switch (true) {
    case hasBenefitsWithReceiverForms && hasBenefitsWithPdfForms:
      return "Pobierz, wypełnij, dostarcz dokumenty oraz poinformuj osoby, których adresy email podałeś, aby wypełniły formularze.";
    case hasBenefitsWithReceiverForms:
      return "Poinformuj osoby, których adresy e-mail podałeś, aby wypełniły formularze.";
    case hasBenefitsWithPdfForms || showOfflineDeclarations:
      return "Pobierz, wypełnij, dostarcz dokumenty.";
    default:
      return null;
  }
};

const RequiredActivities: FC<IRequiredActivitiesProps> = ({
  hasReceiverFormsToFill,
  hasPdfBarcodes,
  showOfflineDeclarations,
  data,
}) => {
  const [initialData, setInitialData] =
    useState<ISubscriptionUserCurrent>(data);

  const activities = useMemo(() => {
    if (!initialData) return [];
    return getRequiredActivitiesMUI(initialData, false, setInitialData);
  }, [initialData]);

  const messageType = setMessageType(
    hasReceiverFormsToFill,
    hasPdfBarcodes,
    showOfflineDeclarations
  );

  if (!data) return null;

  return (
    <Paper
      elevation={3}
      sx={{
        backgroundColor: "#fff",
        width: "100%",
        border: "none",
        borderRadius: { lg: 2 },
        p: { xs: 3, lg: 4 },
        px: { xs: 2, lg: 4 },
        my: { xs: 3, lg: 4 },
      }}
    >
      <Typography variant="h2">{__("Wymagane czynności")}</Typography>
      {messageType ? (
        <Alert severity="warning" sx={{ my: 2 }}>
          <AlertTitle sx={{ fontWeight: 400 }}>{__(messageType)}</AlertTitle>
          <Typography variant="body2" sx={{ mt: 0.5, mb: 0 }}>
            {__("W przeciwnym razie aktywacja abonamentów nie będzie możliwa.")}
          </Typography>
        </Alert>
      ) : (
        <Typography variant="body2" sx={{ my: 2 }}>
          {__("W przeciwnym razie aktywacja abonamentów nie będzie możliwa.")}
        </Typography>
      )}
      <SubscriptionActivitiesList activities={activities} />
    </Paper>
  );
};

export default RequiredActivities;
